import { useEffect } from "react";
import { sendGtmEvent } from "./definitions";

// eslint-disable-next-line import/prefer-default-export
export function usePageTracking(name: string): void {
  useEffect(
    function initPageTracking() {
      sendGtmEvent({ event: name });
    },
    [name]
  );
}
